/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualSaleDto } from '../../models/backend-actual-sale-dto';
import { BackendActualSaleRequestDto } from '../../models/backend-actual-sale-request-dto';

export interface MonitoringActualsSalesUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body: BackendActualSaleRequestDto;
}

export function monitoringActualsSalesUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsSalesUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualSaleDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsSalesUpdate$XWwwFormUrlencoded.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualSaleDto>;
    }),
  );
}

monitoringActualsSalesUpdate$XWwwFormUrlencoded.PATH = '/api/monitoring/actuals/sales/{id}/';
